import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { Translation } from '@/hoslog-intl';
import { FileIcon } from '@/icons';
import { useStorePaymentLogStoreName } from '../hooks/useStorePaymentLogStoreName';

export const StorePaymentLogTitle = ({ storeId }: { storeId: string }) => {
  const { displayName } = useStorePaymentLogStoreName(storeId);

  return (
    <div className="flex items-center gap-1">
      {displayName ? <span>{displayName}: </span> : null}
      <Translation id="paymentManagement.storePaymentLogs.paymentLogs.title" />
    </div>
  );
};

export const StorePaymentLogCrumb = ({ storeId }: { storeId: string }) => {
  const { displayName } = useStorePaymentLogStoreName(storeId);

  return (
    <div className="flex items-center gap-1">
      <CrumbTitle id="" icon={FileIcon} />
      <span>{displayName || ''}</span>
    </div>
  );
};
